import styled from 'styled-components'

export const FinishedGamesContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #111111;
`

export const FinishedGamesWrapper = styled.div`
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 50px 32px;

    @media screen and (max-width: 1000px){
        // grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px){
        // grid-template-columns: 1fr;
        padding: 0 20px;
    }
`

export const FinishedGamesCard = styled.div`
    background: #1a1a1a;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: left;
    border-radius: 10px;
    max-height: 340px;
    max-width: 1100px;
    width: 100%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease-in-out;
    overflow: hidden;
    margin-bottom: 32px;

    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        // cursor: pointer;
        box-shadow: 0px 0px 10px 5px #ff1a1a;
    }

    @keyframes glow {
        from {
          box-shadow: 0 0 5px -5px #ff1a1a;
        }
        to {
          box-shadow: 0 0 5px 5px #ff1a1a;
        }
      }


`

export const FinishedGamesIcon = styled.img`
    width: 40%;
    overflow: hidden;
    object-fit: contain;
`

export const FinishedGamesH1 = styled.h1`
    font-size: 2.5rem;
    color: #fff;
    margin-bottom: 64px;

    @media screen and (max-width: 768px){
        font-size: 2rem;
        margin-bottom: 48px;
    }
    
    @media screen and (max-width: 480px){
        font-size: 1.5rem;
        margin-bottom: 36px;
    }
`

export const FinishedGamesH2 = styled.h2`
    font-size: 1.25rem;
    margin-bottom: 10px;
    text-transform: uppercase;

    @media screen and (max-width: 768px){
        font-size: 1rem;
        margin-bottom: 5px;
    }

    @media screen and (max-width: 480px){
        margin-bottom: 0px;
        font-size: 0.75rem;
    }
`

export const FinishedGamesP = styled.p`
    font-size: 0.9rem;
    text-align: left;

    @media screen and (max-width: 768px){
        font-size: 0.65rem;
    }

    @media screen and (max-width: 480px){
        font-size: 0.4rem;
    }
`

export const FinishedGamesContentWrapper = styled.div`
    color: #fff;
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: left;
    max-height: 340px;
    width: 100%;
    overflow: hidden;
    border-left: solid;
    border-color: #ff1a1a
`

export const FinishedGamesContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: left;
    width: 100%;
`

export const FinishedGamesRating = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 20%;
    padding: 10px;
`

export const FinishedGamesA = styled.a`
    text-transform: uppercase;
    font-weight: bold;
    text-decoration: underline;
    color: #fff;
    margin-top: auto;
    width: fit-content;
    font-size: 0.9rem;

    &:hover{
        color: #ff1a1a;
        transition: 0.3s ease-out;
    }

    @media screen and (max-width: 768px){
        font-size: 0.65rem;
    }

    @media screen and (max-width: 480px){
        font-size: 0.4rem;
    }
`


//new

export const FGContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // padding: 10px;
    // background-color: #fff;
    width: 100%;
    height: fit-content;
    margin-top: 10px;
    margin-bottom: 10px;

    margin-bottom: 64px;

    @media screen and (max-width: 768px){
        margin-bottom: 48px;
    }
    
    @media screen and (max-width: 480px){
        margin-bottom: 36px;
    }
`

export const FGWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 75%;
    justify-content: center;
    align-items: top;
    -webkit-box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.75);


`

export const FGCard = styled.div`
    background-color: rgba(255, 255, 255, 0.02);
    max-height: 324px;
    width: 100%;
    border-radius: 0px;
    display: flex;
    justify-content: left;
    align-items: center;    
    border-bottom: solid 2px rgba(255,26,26,.25);


    &:hover{
        transition: all 0.2s ease-in-out;
        //background: rgba(255,26,26,1);


    }
    padding: 1%;
`

export const FGIcon = styled.img`
    object-fit: cover;
    height: 100%;
    width: 20%;
    border-radius: 5%;
`

export const FGCardContent = styled.div`
    padding-left: 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:hover{
        overflow: visible; 
        white-space: normal;
        height:auto;
    }
`

export const FGH1 = styled.h1`
    color: #fff;
    text-transform: uppercase;
    font-size: 1.5em;
    font-weight: 600;
    margin-bottom: 5px;
    letter-spacing: .05em;

    @media screen and (max-width: 768px){
        font-size: 1em;
    }

    @media screen and (max-width: 480px){
        font-size: 0.7em;
    }

`

export const FGH2 = styled.h2`
    font-size: 1em;
    font-weight: 500;
    margin-bottom: 5px;
    letter-spacing: .05em;
    color: #fff;

    &:nth-child(n){
        border-right: solid 2px #ff1a1a;
        padding-right: 10px;
    }

    &:nth-child(n+2){
        padding-left: 10px;
    }

    &:nth-last-child(1) {
        border-right: none;
    }

    @media screen and (max-width: 768px){
        font-size: 0.85rem;
    }

    @media screen and (max-width: 480px){
        font-size: 0.6rem;
    }


`

export const FGTags = styled.div`
    display: flex;
}   
`

export const FGHeader = styled.h1`
    color: #fff;
    text-transform: uppercase;
    font-size: 2rem;

    margin-bottom: 64px;
    text-align: center;

    @media screen and (max-width: 768px){
        font-size: 2rem;
        margin-bottom: 48px;
    }
    
    @media screen and (max-width: 480px){
        font-size: 1.5rem;
        margin-bottom: 36px;
    }
`

export const FGA = styled.a`
    text-transform: uppercase;
    font-weight: bold;
    text-decoration: underline;
    color: #fff;
    width: fit-content;


    &:hover{
        color: #ff1a1a;
        transition: 0.3s ease-out;
    }
`